import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledDDItemContainer = styled.div<{ width?: number }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${({ width }) => `width:${width ? `${width}px` : "100%"}`}
`;

export const StyledDDContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const StyledRegionDDText = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;
export const StyledMainContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledLockedIconContainer = styled.div`
    display: flex;
`;

export const StyledLockedIcon = styled(SWReactIcons)`
    height: 14px;
    width: 14px;
`;
export const StyledRegionIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${SWReactIcons} {
        display: flex;
    }
`;
